import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import classNames from 'classnames'
import {memo} from 'react'

import {formatDurationWithMilliseconds} from '../../../../../../../../utils/dateTimeUtils'
import Popup from '../../../../../../../common/Popup/Popup.lazy'

import {POPUP_DIRECTIONS} from './BarPopup'
import type {AverageProps} from './BarPopup.types'

import styles from './BarPopup.css'

function BarAveragePopup({anchor, duration, buildsCount, date}: AverageProps) {
  return (
    <Dropdown className={styles.wrapper} anchor={anchor} hoverMode>
      <Popup
        directions={POPUP_DIRECTIONS}
        className={classNames(styles.popup, styles.average)}
        autoCorrectTopOverflow={false}
      >
        <div className={styles.content}>
          <div>{'Duration'}</div>
          <div className={styles.durationValue}>{formatDurationWithMilliseconds(duration)}</div>
          <div>{'Builds'}</div>
          <div>{buildsCount}</div>
          <div>{'Date'}</div>
          <div>{date}</div>
        </div>
      </Popup>
    </Dropdown>
  )
}

export default memo<AverageProps>(BarAveragePopup)
